import StateSwitch from '../classes/stateSwitch.class';
import { addAllListeners, removeAllListeners } from '../modules/events';
// GLOBAL
export var stateSwitch = null;
/**
 * Сreates a global object stateSwitch and
 * After сreates and configures all dependent event listeners
 */
export var createStateSwitch = function (verifiedConfig) {
    stateSwitch = new StateSwitch(verifiedConfig);
    window.sznIVA.spenttime.conf = function () { return stateSwitch.config; };
    addAllListeners();
};
/**
 * Remove all dependent event listeners and a global object stateSwitch
 */
export var removeStateSwitch = function () {
    removeAllListeners();
    window.sznIVA.spenttime.conf = function () { return null; };
    stateSwitch = null;
};
